import React, { useEffect, useState } from "react";
import { Typography, Button, Avatar, CircularProgress } from "@mui/material";
import DoneImage from "../Components/assets/Images/congratsdoneimage.svg";
import ErrorImage from "../Components/assets/Images/errorImage.svg";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IGetDocumentDigilocker } from "../shared/dtos";
import { PanDigilockerDocumentGetAPICall } from "../shared/APICalls";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import styles from "../Pages copy/Redirect.module.scss";
import { REDIRECTURL } from "../shared/constants";

export default function PANCR() {
  const [countDown, setCountDown] = useState(3);
  const [errorMesage, seterrorMessage] = useState("");
  const [loading, setloading] = useState(false);
  const [displayError, setDisplayError] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const doc_id = params.id;
  const state = params.state;
  //   const state = params.state;
  sessionStorage.setItem("access-token", state);

  // console.log("doc_id", doc_id);

  const GetpanDoc = () => {
    let obj: any = {
      setu_id: doc_id,
      // doc_type: "PANCR",
    };
    setloading(true);
    PanDigilockerDocumentGetAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setloading(false);
        //   console.log("responseDataResponse", responseData);
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}uploaddocuments`;
        }, 3000);
      })
      .catch((error: any) => {
        setloading(false);
        setDisplayError(true);
        seterrorMessage(
          error.response?.data?.error?.message
            ? error.response.data.error.message
            : "Error fetching document"
        );
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}uploaddocuments`;
        }, 3000);
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  useEffect(() => {
    if (window.location.href.includes("Cancelled")) {
      // console.log("cancel");
      setDisplayError(true);
    } else {
      setDisplayError(false);
      GetpanDoc();
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(3);
    }
  }, [countDown]);

  return (
    <>
      <ErrorSnackBar message={errorMesage} />
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={displayError ? ErrorImage : DoneImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : displayError
                  ? "Failed to fetch the data"
                  : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirected in 3 seconds.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
